import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=564d57d2&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"
import style0 from "./EventList.vue?vue&type=style&index=0&id=564d57d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d57d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564d57d2')) {
      api.createRecord('564d57d2', component.options)
    } else {
      api.reload('564d57d2', component.options)
    }
    module.hot.accept("./EventList.vue?vue&type=template&id=564d57d2&scoped=true&", function () {
      api.rerender('564d57d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/events/EventList.vue"
export default component.exports